import { inject, provideEnvironmentInitializer } from '@angular/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json'

export function provideBelegpruefung() {
  return [
    provideEnvironmentInitializer(() => {
      const store = inject(Store);
      store.commit(
        SOFTLINE_FEATURE_TRANSLATION,
        TranslationStore.mutations.add,
        {
          module: 'belegpruefung',
          language: 'de',
          translations: de,
        }
      );
    })
  ]
}
